import React from 'react';
import { useSubtramiteForm } from '../../../hooks/useSubtramiteForm';
import { savePlanoMensura } from '../../../services/tramiteService';
import SubtramiteForm from '../../SubtramiteForm';
import { validaTiempo } from '../../../utils/validaciones';
import { useAuth } from '@/auth';
import { checkAllPermissions, checkAnyPermissions, PERMISSIONS } from '@/auth/permissions';
import { withRequiredTramite } from './withRequiredTramite';

const PlanoMensura: React.FC = () => {

  const {
    data,
    loading,
    init,
    isUpdate,
    setIsUpdate,
    handleChange,
    handleSubmit,
    handleFinalizarSubtramite,
    handleReabrirSubtramite
  } = useSubtramiteForm({
    subtramiteKey: 'planomensura',
    defaultData: {
      habilitado: true,
      fecini: new Date(),
      plano: null,
      plano_path: null,
    },
    saveFunction: savePlanoMensura,
    successMessage: 'PlanoMensura Guardado con éxito',
    errorTitle: 'Error al grabar PlanoMensura',
  });

  const { user } = useAuth();
  const userPermissions = user?.permissions || [];
  const canManageTramites = checkAllPermissions(userPermissions, [PERMISSIONS.MANAGE_TRAMITES.name]);
  const canUploadPlanos = checkAnyPermissions(userPermissions, [
    PERMISSIONS.MANAGE_TRAMITES.name,
    PERMISSIONS.UPLOAD_PLANOS_FILES.name
  ]);

  // Configuración de campos básicos
  const fields = [
    {
      type: 'toggle',
      name: 'habilitado',
      label: 'Habilitado:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
    {
      type: 'date',
      name: 'fecini',
      label: 'Fecha de inicio:',
      inline: true,
      visible: canManageTramites && !isUpdate,
    },
  ];

  const canEditPlano = canManageTramites || (canUploadPlanos && validaTiempo(data.plano_path, data.plano_udt));

  // Configuración de campos de archivos
  const fileFields = [
    {
      type: 'file',
      name: 'plano',
      label: 'Plano:',
      pathField: 'plano_path',
      visible: isUpdate,
      readOnly: !canEditPlano,
      helpText: 'Acción a realizar por la tramitadora o vendedor',
    },
  ];

  const btnGuardarVisible = fields.some(field => field.visible) ||
    fileFields.some(field => field.visible && !field.readOnly);


  return (
    <SubtramiteForm
      title="Plano de Mensura"
      data={data}
      loading={loading}
      init={init}
      isUpdate={isUpdate}
      setIsUpdate={setIsUpdate}

      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleFinalizarSubtramite={handleFinalizarSubtramite}
      handleReabrirSubtramite={handleReabrirSubtramite}
      btnGuardarVisible={btnGuardarVisible}
      fields={fields}
      fileFields={fileFields}
      subtramiteKey="planomensura"
    />
  );
}

export default withRequiredTramite(PlanoMensura);